import { auth0 } from '@/auth0';
import axios from 'axios';

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_ENDPOINT,
});

apiClient.interceptors.request.use(
  async (config) => {
    const token = await auth0.getAccessTokenSilently();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Handle 401 (Unauthorized) - Token expired
    if (error.response && error.response.status === 401) {
      await auth0.logout();
    }

    // Handle other errors
    if (error.response && error.response.status === 403) {
      // Handle forbidden
      console.error('Access forbidden');
    }

    return Promise.reject(error);
  },
);
